<template lang="html">
<div class="pgInner atvEdit">

    <div class="headBar">新建实验室</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <el-form ref="ruleForm" :model="params" :rules="rules" inline-message="true" :show-message="true">

               <div class="tabContent">

                 <div class="text-block clearfix">
                     <div class="bName">
                        <span class="dot">*</span>
                        <span>机构名称</span>
                     </div>
                     <div class="bContent">
                           <el-form-item prop="title">
                               <el-input size="medium" class="inpText" v-model="params.title" placeholder="请输入机构名称"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">依托单位</div>
                     <div class="bContent">
                           <el-form-item>
                               <el-input size="medium" class="inpText" v-model="params.publishCompany" placeholder="请输入依托单位"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">
                         <span class="dot">*</span>
                         <span>简介</span>
                     </div>
                     <div class="bContent">
                         <textEditor ref="textEditor" :inContent="params.content" />
                         <!-- <editor id="editor_id" height="500px" width="100%" :content="params.content"
                         @on-content-change="contentChange"
                         pluginsPath="/static/kindeditor/plugins/"
                         :loadStyleMode="false"></editor> -->
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">联系人</div>
                     <div class="bContent">
                           <el-form-item prop="contactPerson">
                               <el-input size="medium" class="inpText" v-model="params.contactPerson" placeholder="请输入联系人"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">
                         <span class="dot">*</span>
                         <span>联系电话</span>
                     </div>
                     <div class="bContent">
                           <el-form-item prop="contactPhone">
                               <el-input size="medium" class="inpText" v-model="params.contactPhone" placeholder="请输入联系电话"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">地址</div>
                     <div class="bContent">
                           <el-form-item>
                               <ads-select @selected="mapChange" :adsList="adsStore"  selectType="1" />
                           </el-form-item>
                     </div>
                 </div>

               </div>

            </el-form>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

      <div v-if="pgState" class="loading">
           <span v-if="pgState == 1">初始化中...</span>
           <span v-if="pgState == 2">数据保存中...</span>
           <i class="el-icon-loading"></i>
      </div>
      <div v-else>
           <el-button @click="directSave" type="primary" size="small">保存</el-button>
           <el-button @click="goReturn" plain size="small">取消</el-button>
      </div>

    </div>

</div>
</template>

<script>
import Editor from "@/components/KindEditor/KindEditor";
import { msgCreate,msgPredat,adsCreate } from "@/api/message/message";
let isPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('联系电话不能为空'));
    }else{
        let pattern = /^1[3|4|5|7|8][0-9]{9}$/;
        if(pattern.test(value)){
            callback();
        }else{
            return callback(new Error('联系电话格式不正确'));
        }
    }
}
export default {
    components:{
        Editor
    },
    computed:{
      pgState:function(){
          var state = 0;
          if(this.params.id && !this.readyKey){
              state = 1;
          }

          if(this.uploadIng){
              state = 2;
          }

          return state;
      }
    },
    data(){
        return{

            pageH:'',
            id:'',
            uploadIng:false,
            readyKey:false,

            adsStore:{},

            params:{
                id:'',
                businessNewsTypeId:'',
                businessNewsId:'',

                title:'',
                publishCompany:'',

                latitude:'',
                longitude:'',
                address:'',

                content:'',
                contactPerson:'',   // 联系人
                contactPhone:'',    // 联系电话

                status:3,
            },

            preCode:'',
            pgName:'',

            rules:{
                title:[{
                    required: true,
                    message: '机构名称必须填写',
                    trigger: 'blur'
                }],
                contactPhone:[{
                    validator: isPhone,
                    trigger: 'blur'
                }],
            }

        }
    },

    methods:{
        goReturn:function(){
            this.$router.go(-1);
        },

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },

        goCreate:function(){  // 创建
            var vues = this;
            this.uploadIng = true;
            msgCreate({businessNews:vues.params}).then(res => {
                if(!vues.params.businessNewsId){
                    vues.params.businessNewsId = res.businessNews.id;
                    vues.uploadIng = false;
                    this.$router.push('exp_message');
                }
            }).catch(err => {
                // vues.$message.error('保存错误！')
            });
        },

        tmSave:function(){
            var vues = this;
            this.waitSave = setInterval(function(){
                var nowCode = JSON.stringify(vues.params);
                if(nowCode !== vues.preCode){
                    vues.goCreate(2);
                    vues.preCode = nowCode;
                }
            },60000)
        },

        directSave:function(status){
            var vues = this;
            this.$refs.ruleForm.validate((valid) => {
                if(valid){
                  vues.params.content = this.$refs.textEditor.editorContent;
                  if(!vues.params.content){
                    vues.$message.error('简介不能为空!');
                  }else{
                    vues.goCreate(status);
                  }

                }

            })
        },

        mapChange:function(e){    //  位置地点
            this.params.address = e.name + ',' + e.id;
            if(e.address){
                this.params.address = this.params.address  + ',' + e.address;
            };
            this.params.latitude = e.latLng.lat;
            this.params.longitude = e.latLng.lng;
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;

            this.params.businessNewsTypeId = querys.typeid;

            // 底部定位
            this.pageFix();

            if(querys && querys.id){
                this.id = querys.id;
                this.params.id = querys.id;
                msgPredat({id:querys.id}).then(res => {
                    vues.readyKey = true;
                    vues.params = res.businessNews;
                    if(res.businessOfficeLocation){
                        vues.params = res.businessOfficeLocation;
                    }
                    // 所在地点
                    vues.adsStore = [{
                        name:this.params.address.split(',')[0],
                        id:this.params.address.split(',')[1],
                        address:this.params.address.split(',')[2],
                        latLng:{
                           lng:this.params.longitude,
                           lat:this.params.latitude
                        }
                    }];
                })
            }else{
                this.preCode = JSON.stringify(this.params);
            }

        },
    },
    created:function(){
        var vues = this;

        $(window).on('resize',function(){
    		     vues.pageFix();
    	  })

        this.prevSet();


    },

    beforeDestroy:function(){
        $(window).off('resize');
        clearInterval(this.waitSave);
    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
}

.tabNavs{
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem{
     float: left;
     height: 50px;
     line-height: 50px;
     font-size: 15px;
     margin-right: 45px;
     cursor: pointer;
  }
  .tabItem.act{
    color: rgb(86, 119, 252);
  }
  .moveLine{
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading{
     font-size: 14px;
     padding-left: 24px;
     color: #AEAEAE;
     i{
         font-size: 18px;
         vertical-align: middle;
     }
  }
}

.text-block{
      font-size: 14px;
     .bName{
         width: 80px;
         padding-top: 8px;
         float: left;
         .dot{
             color: salmon;
             display: inline-block;
             vertical-align: middle;
             margin-top: 3px;
         }
     }
     .bContent{
          margin-left: 80px;
          position: relative;
          margin-bottom: 20px;

          .inpText{
               width: 420px;
          }
     }
}

.radio-block .el-radio-group{
     margin-top: 12px;
}

.tag-block{
   margin-top:20px;
   .bName{
        padding-top: 5px;
   }
}


</style>

<style lang="css">

.atvEdit .el-input__inner{
    border-radius: 0px;
}

</style>



// WEBPACK FOOTER //
// expEdit.vue?f41a1ee8